<script setup lang="ts">
import { ref, watch } from 'vue'
import { SelectCards } from '@/modules/shared/components'
import { useWorkspaceOnboardingStore } from '../../stores/workspace-onboarding-store'
import { useWorkspaceSettingsStore } from '../../stores/workspace-settings-store'

const onboardingStore = useWorkspaceOnboardingStore()
const settingsStore = useWorkspaceSettingsStore()

const setupMode = ref(true)

watch(
  () => onboardingStore.workspace,
  (ws) => {
    if (ws) setupMode.value = ws.setup_mode ?? true
  },
  { immediate: true },
)

const submit = async (): Promise<boolean> => {
  await settingsStore.updateWorkspace({ setup_mode: setupMode.value }, { silent: true })
  await onboardingStore.fetch()
  return true
}

defineExpose({ submit })
</script>

<template>
  <div class="flex flex-1 flex-col">
    <SelectCards
      v-model="setupMode"
      :options="[
        { label: 'Enabled', value: true, description: 'Build out your workspace quietly before going live.' },
        { label: 'Disabled', value: false, description: 'Go live immediately and notify as you add.' },
      ]"
      :columns="2"
    />
  </div>
</template>
